import { BriefcaseBusinessIcon, UserIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export const ClientTypeSwitch = ({
  isCompany,
  onToggle,
}: {
  isCompany: boolean;
  onToggle: (isCompany: boolean) => void;
}) => {
  return (
    <div className="flex items-center">
      <button
        onClick={() => onToggle(true)}
        className={cn(
          "box-border flex cursor-pointer items-center gap-1 rounded-l-lg border px-3 py-2 text-xs font-semibold transition-colors",
          isCompany
            ? "border-black bg-black text-white"
            : "text-muted-foreground bg-transparent",
        )}
      >
        <BriefcaseBusinessIcon size={16} /> Na firmę
      </button>
      <button
        onClick={() => onToggle(false)}
        className={cn(
          "box-border flex cursor-pointer items-center gap-1 rounded-r-lg border px-3 py-2 text-xs font-semibold transition-colors",
          !isCompany
            ? "border-black bg-black text-white"
            : "text-muted-foreground bg-transparent",
        )}
      >
        <UserIcon size={16} /> Dla Ciebie
      </button>
    </div>
  );
};
